export { default } from './es/icons/ZoomFilled';